module.exports = __webpack_public_path__ + "img/vp.608e1f38.png";